import { count, eq } from "drizzle-orm";
import {
  list_organization,
  member,
  organization,
  type PowerSyncDrizzleDB,
  user,
} from "@listto/powersync";

/**
 * Shared Drizzle query builder for fetching organization counts.
 */
export function getOrganizationCountQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({
      count: count(organization.id).mapWith(Number),
    })
    .from(organization);
}

/**
 * Shared Drizzle query builder for fetching the organization linked to a list.
 */
export function getListOrganizationQuery(db: PowerSyncDrizzleDB, listId: string) {
  return db
    .select({
      organization_id: list_organization.organization_id,
    })
    .from(list_organization)
    .where(eq(list_organization.list_id, listId))
    .limit(1);
}

/**
 * Possible assignees of a task in list `listId`: members of
 * organizations list is shared with (data already synchronized
 * locally via `organizations`/`org_lists` streams). In personal
 * lists returns empty — there only owner self-assignment fits.
 */
export function getListAssigneesQuery(db: PowerSyncDrizzleDB, listId: string) {
  return db
    .selectDistinct({
      id: user.id,
      name: user.name,
      email: user.email,
      image: user.image,
    })
    .from(member)
    .innerJoin(list_organization, eq(member.organization_id, list_organization.organization_id))
    .innerJoin(user, eq(user.id, member.user_id))
    .where(eq(list_organization.list_id, listId));
}

/** Fila devuelta por `getListAssigneesQuery`. */
export interface ListAssignee {
  id: string;
  name: string | null;
  email: string | null;
  image: string | null;
}
